import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Meniu from "@/pages/Meniu";
import Galerie from "@/pages/Galerie";
import Rezervari from "@/pages/Rezervari";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/meniu" element={<Meniu />} />
            <Route path="/galerie" element={<Galerie />} />
            <Route path="/rezervari" element={<Rezervari />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
